module.exports = __webpack_public_path__ + "img/5b8bd1a.jpg";